/**
 * ResponsibleGamingOptionData.ts
 */
export class ResponsibleGamingOptionData {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
    isEqual(data) {
        let equal = false;
        if (data) {
            equal = this.type == data.getType() && this.value == data.getValue();
        }
        return equal;
    }
    getValue() {
        return this.value;
    }
    getType() {
        return this.type;
    }
    isExtraSpin() {
        return this.type.isExtraSpin();
    }
    isSpinPrice() {
        return this.type.isSpinPrice();
    }
    isSingleGameStake() {
        return this.type.isSingleGameStake();
    }
    isMaximumLoss() {
        return this.type.isMaximumLoss();
    }
    toString() {
        return this.type.getId() + " : " + this.value;
    }
}
//# sourceMappingURL=ResponsibleGamingOptionData.js.map